import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import FloodsInAccumulation from '../../components/calculation-form/components/form-items/floods-in-accumulation'
import { onAnyStandardCell } from '../../helpers/helpers'
import { CalculationColumn } from '../../types/column-types'

export const floodsInAccumulation: CalculationColumn = {
    dataIndex: 'floodsInAccumulation',
    title: (
        <RotatedTitle style={{ whiteSpace: 'nowrap' }}>
            Ручьи в<br />
            сборке
        </RotatedTitle>
    ),
    width: 40,
    editable: true,
    FormItem: <FloodsInAccumulation />,
    onCell: onAnyStandardCell,
}
